"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _axios = _interopRequireDefault(require("axios"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _core2 = require("@stt-componentes/core");
var _SttBox = _interopRequireDefault(require("../../dist/lib/SttLayout/SttBox"));
var _SttHeading = _interopRequireDefault(require("../../dist/lib/SttTypography/SttHeading"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    card: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
      alignItems: 'center'
    },
    textCenter: {
      textAlign: 'center'
    },
    modal: {
      overflowY: 'auto'
    },
    semHistoricoBox: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
      margin: theme.spacing(1.5)
    }
  };
});
var MateriaisSuporte = function MateriaisSuporte(props) {
  var strings = props.strings,
    headers = props.headers,
    config = props.config,
    open = props.open,
    setOpen = props.setOpen;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    materiais = _useState2[0],
    setMateriais = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    baixouMateriais = _useState4[0],
    setBaixouMateriais = _useState4[1];
  var classes = useStyles();
  var UTILITARIOS_API_BASE_URL = config.url_base_utilitarios;
  (0, _react.useEffect)(function () {
    _axios["default"].get("".concat(UTILITARIOS_API_BASE_URL, "/materiais"), {
      headers: headers,
      params: {
        modulo: config.modulo_sigla
      }
    }).then(function (response) {
      if (response) {
        setMateriais(response.data);
        setBaixouMateriais(true);
      }
    })["catch"](function (err) {
      console.log(err);
      setBaixouMateriais(true);
    });
    var messageListener = function messageListener(e) {
      var _e$data;
      if (!e) return;
      var acao = ((_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.acao) || null;
      if (acao === 'ABRIR_MATERIAL_SUPORTE') {
        setOpen(true);
      }
    };
    window.addEventListener('message', messageListener);
    return function () {
      window.removeEventListener('message', messageListener);
    };
  }, []);
  var handleCloseModal = function handleCloseModal() {
    setOpen(false);
  };
  return /*#__PURE__*/_react["default"].createElement(_core2.SttModal, {
    title: strings.materiaisSuporte,
    open: open,
    outModalClose: handleCloseModal,
    maxWidth: "lg",
    fullWidth: true,
    className: classes.modal,
    iconClose: handleCloseModal,
    children: /*#__PURE__*/_react["default"].createElement(_core2.SttGrid, {
      container: true,
      spacing: 3
    }, baixouMateriais && materiais.length === 0 ? /*#__PURE__*/_react["default"].createElement(_SttBox["default"], {
      className: classes.semHistoricoBox
    }, /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
      variant: "h2"
    }, "Sem material de apoio cadastrado para esse m\xF3dulo.")) : materiais.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement(_core2.SttGrid, {
        item: true,
        xs: 12,
        sm: 6,
        md: 4,
        lg: 3,
        key: item.id
      }, /*#__PURE__*/_react["default"].createElement(_core.Card, {
        className: classes.card
      }, /*#__PURE__*/_react["default"].createElement(_core.CardActionArea, {
        className: classes.textCenter,
        disableRipple: true,
        onClick: function onClick() {
          return window.open(item.url, '_blank');
        }
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: item.thumbnail
      })), /*#__PURE__*/_react["default"].createElement(_core2.SttText, {
        className: classes.textCenter
      }, item.nome), /*#__PURE__*/_react["default"].createElement(_core2.SttText, {
        className: classes.textCenter
      }, item.data), /*#__PURE__*/_react["default"].createElement("img", {
        src: item.qrCode,
        style: {
          maxWidth: 180,
          maxHeight: 180
        }
      })));
    })),
    footer: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_core2.SttButton, {
      variant: "contained",
      color: "primary",
      onClick: handleCloseModal
    }, "Fechar"))
  });
};
MateriaisSuporte.propTypes = {
  strings: _propTypes["default"].object.isRequired,
  config: _propTypes["default"].object.isRequired,
  headers: _propTypes["default"].object.isRequired,
  open: _propTypes["default"].bool.isRequired,
  setOpen: _propTypes["default"].func.isRequired
};
var _default = MateriaisSuporte;
exports["default"] = _default;